import { get } from 'svelte/store'

import { configStore } from '@src/stores/config'
import { PassportEvents, dispatch } from '@lib/events/events'
import { analytics } from '@lib/mixpanel/mixpanel'
import { requestPromoLoyaltyPoints } from '@lib/loyalty'

import { getAddress } from './blockchain'

export async function requestLoyaltyPoints(eventId: number, contractAddress: string) {
  try {
    const { chainId, clientId, credenza } = get(configStore)

    await requestPromoLoyaltyPoints({
      eventId,
      contractAddress,
      chainType: 'evm',
      apiUrl: credenza.generalApiUrl,
      evmChainId: chainId,
    })

    const log = {
      chain: chainId,
      clientId,
      contract: contractAddress,
      eventId,
      from: await getAddress(),
    }
    dispatch(PassportEvents.REQUEST_LOYALTY_POINTS, log)

    analytics.track('cp_request_loyalty', log)
  } catch (err) {
    dispatch(PassportEvents.ERROR, {
      error: { message: err.statusText, title: 'Request loyalty points failed', code: err.status },
    })
    throw err
  }
}
